import React from 'react';
import { 
	func,
	string,
	number,
	array,
	object
} from 'prop-types';
import DisableBackground from '../../atoms/DisableBackground/index';
import EditOptions from '../../molecules/EditOptions/index';
import NewItemForm from '../../molecules/NewItemForm/index';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import style from'./style';

const OptionComponent = ({answer,candidates,onDelete,onSort,t,...props}) =>{
	if(candidates && candidates.length > 1) return <EditOptions 
		{...props}
		t={t}
		key={candidates}
		data = {candidates}
		answer = {answer}
		onDelete = {onDelete}
		onSort = {onSort}
	/>;
	return <DisableBackground {...props}>
		<div>{t('create-quiz-modal.NoOption')}</div>
	</DisableBackground>;
};

const Presenter = ({
	answer,
	candidates,
	number,
	errorMessage,
	onBackClicked,
	onNextClicked,
	answerCandidateListProps,
	addChoice,
	handleChangeBlankSize,
	blankSize = 0,
	t
})=> {
	return (
		<style.Content>
			<style.AnswerHeader>
				<style.TextButton onClick={onBackClicked}>
						Back
				</style.TextButton>
				<style.AnswerWrapper>
					<style.AnswerNo>{'Q('+(number+1)+') Answer'}</style.AnswerNo>
					<style.AnswerLabel>
						{answer}
					</style.AnswerLabel>
				</style.AnswerWrapper>
				<style.TextButton onClick={onNextClicked}>
						Next
				</style.TextButton>
			</style.AnswerHeader>
			<style.ErrorMessage>
				{errorMessage}
			</style.ErrorMessage>
			<style.Divider/>
			<style.BlankSize>
				<style.BlankSizeCaption>{t('create-quiz-modal.BlankSize')}</style.BlankSizeCaption>
				<style.BlankTextInput value={blankSize} onChange={handleChangeBlankSize}/>
			</style.BlankSize>
			<style.Divider/>
			<NewItemForm 
				key={candidates}
				onAddItem={addChoice}
				placeholder={t('create-quiz-modal.InputOption')}
			/>
			<style.OptionsWrapper>
				<OptionComponent 
					key={candidates}
					answer={answer}
					candidates={candidates}
					t={t}
					{...answerCandidateListProps}
				/>
			</style.OptionsWrapper>
		</style.Content>
	);
	
};
Presenter.propTypes = {
	number : number.isRequired,
	answer:string,
	candidates:array,
	errorMessage:string,
	onChangeChoice : func,
	onNextClicked : func,
	onBackClicked : func,
	answerCandidateListProps : object,
	onAdd : func,
	t : func.isRequired
};

export default withNamespaces()(Presenter);